import { useUserStarId } from '@store'

import { useStarById } from './useStarById'

export const useUserStar = () => {
  const userStarId = useUserStarId()
  const { star: userStar } = useStarById({ starId: userStarId || '' })

  return { userStar }
}
